// import moment from "moment";

import http from "@seims/shared/src/services/HttpService";

var endpoint = 'events';

const getEventsByStatus = async ({ statusKey, first, max, text = null }) => {
  var urlPath = `${endpoint}/ratification/status/${statusKey}?offset=${first}&limit=${max}`;

  if (text !== null && text !== undefined && text !== "") {
    urlPath += `&searchText=${text.toLowerCase()}`;
  }

  const response = await http.get(urlPath);
  return response;
};

const getEventDetails = async (eventId) => {
  const response = await http.get(`${endpoint}/ratification/${eventId}`);
  return response;
};

const updateEventStatus = async (data) => {
  const response = await http.put(`${endpoint}/ratification/${data.eventId}`,
    {
      action: data.action,
      notes: data.notes
    }
  );
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { getEventsByStatus, getEventDetails, updateEventStatus };
